import { track } from '@/shared/analytics/openpanel';

export type CompanyEvent =
  | 'company_selected'
  | 'company_switched'
  | 'company_restored'
  | 'company_unavailable'
  | 'company_switch_failed';

export function trackCompanyEvent(event: CompanyEvent, properties?: Record<string, unknown>): void {
  track(event, properties);
}
